import React from "react";
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

interface CustomRadioGroupProps {
  value: string | null;
  onChange: (value: string) => void;
  options: { label: string; value: string }[];
  disabled?: boolean;
  shouldBold?: boolean;
}

const CustomRadioGroup: React.FC<CustomRadioGroupProps> = ({
  value,
  onChange,
  options,
  disabled,
  shouldBold = false,
}) => {
  const normalizedValue = (value || "not checked").toLowerCase();

  const normalizedOptions = options.map((option) => ({
    label: option.label,
    value: option.value.toLowerCase(),
  }));

  const isBMSBoard = normalizedOptions.some((option) =>
    ["bmpro35", "bmproaspero", "victrona", "victronb", "victronc"].includes(
      option.value
    )
  );

  const isInverterTorqued = normalizedOptions.some((option) =>
    ["projecta", "bmpro", "victron2000", "victron3000"].includes(option.value)
  );

  return (
    <FormControl component="fieldset">
      <RadioGroup
        value={normalizedValue}
        onChange={(event) => onChange(event.target.value)}
        sx={{
          display: isBMSBoard || isInverterTorqued ? "flex" : "grid",
          flexDirection: isBMSBoard || isInverterTorqued ? "column" : undefined,
          gridTemplateColumns:
            isBMSBoard || isInverterTorqued ? undefined : "auto auto",
          gap: isBMSBoard ? "8px" : "4px",
          padding: isBMSBoard ? "8px 0" : "4px 0",
        }}
      >
        {normalizedOptions.map((option, index) => (
          <FormControlLabel
            key={index}
            value={option.value}
            control={<Radio size="small" sx={{ p: "4px" }} />}
            label={option.label}
            sx={{
              margin: 0,
              ...(isInverterTorqued || isBMSBoard
                ? {
                    alignItems: "center",
                    columnGap: "6px",
                    ".MuiFormControlLabel-label": {
                      fontSize: "14px",
                      fontWeight: shouldBold ? "bold" : "normal",
                      lineHeight: 1.2,
                      display: "inline-flex",
                      alignItems: "center",
                    },
                  }
                : {
                    alignItems: "center",
                    columnGap: "6px",
                    ".MuiFormControlLabel-label": {
                      fontSize: "14px",
                      fontWeight: shouldBold ? "bold" : "normal",
                      lineHeight: 1.2,
                    },
                  }),
            }}
            disabled={disabled}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default CustomRadioGroup;
